import { render, staticRenderFns } from "./PersonCertificationIndex.vue?vue&type=template&id=c42ed334&scoped=true&"
import script from "./PersonCertificationIndex.vue?vue&type=script&lang=js&"
export * from "./PersonCertificationIndex.vue?vue&type=script&lang=js&"
import style0 from "./PersonCertificationIndex.vue?vue&type=style&index=0&id=c42ed334&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42ed334",
  null
  
)

export default component.exports